import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationOntologyForAutomaticAssayCreateRequest,
    ConfigurationOntologyForAutomaticAssayResponse
} from '@/modules/configurationModule/detail/automation/assays/services/configuration-ontology-for-automatic-assay/configuration-ontology-for-automatic-assay.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationOntologyForAutomaticAssayService {
    async create(laboratoryId: number, request: ConfigurationOntologyForAutomaticAssayCreateRequest): Promise<ConfigurationOntologyForAutomaticAssayResponse> {
        const response = await axios.post<ConfigurationOntologyForAutomaticAssayResponse>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticAssays`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationOntologyForAutomaticAssayResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationOntologyForAutomaticAssayResponse>>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticAssays`, { ...filterModel }, { params })
        return response.data
    }

    async get(laboratoryId: number, ontologyForAutomaticAssayId: number): Promise<ConfigurationOntologyForAutomaticAssayResponse[]> {
        const response = await axios.get<ConfigurationOntologyForAutomaticAssayResponse[]>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticAssays/${ontologyForAutomaticAssayId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/ontologyForAutomaticAssays/batch`, { data: request })
        return response.data
    }
}

export const configurationOntologyForAutomaticAssayService = new ConfigurationOntologyForAutomaticAssayService()
